import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "drinks",
  "use": "drinks-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"drinks\">\n  <path d=\"M21,5 L21,3 L3,3 L3,5 L11,14 L11,19 L6,19 L6,21 L18,21 L18,19 L13,19 L13,14 L21,5 Z M7.43,7 L5.66,5 L18.35,5 L16.57,7 L7.43,7 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol